query getSportsbookPromoFeed($tournamentIds: [String]) {
  sportsbookPromoFeed(tournamentIds: $tournamentIds)
}
